import { slugify } from '../utils/slugify';

// --- Data for Adult Education Course Packages ---
export const coursePackagesData = [
    {
        id: 1,
        name: "Developing Learner Agency",
        slug: slugify("Developing Learner Agency"),
        icon: "💡",
        tileDescription: "A course for educators on how to empower learners to take control of their own learning journey.",
        overview: "This course teaches educators how to support learners to take control of their learning journey and develop skills for lifelong success. By integrating principles of learner agency into our practice educators can support learners to take greater control of their educational journey, making their learning more enjoyable, engaging, and effective. These workshops are for anyone working in education with an interest in supporting learners to succeed.",
        workshops: [
            "Workshop 1 | Learner agency | Developing a positive learner identity",
            "Workshop 2 | Learner agency | Developing personal learning strategies",
            "Workshop 3 | Learner agency | Supporting learners to organise their learning",
            "Workshop 4 | Learner agency | Supporting learners to solve problems, innovate, and learn effectively"
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "$2,000 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "$4,500 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Explore these resources to deepen your understanding of learner agency and discover practical strategies for fostering it in your educational context. These videos offer diverse perspectives and actionable insights.",
            videos: [
                "https://www.youtube.com/embed/S_8XV_t_pM4",
                "https://www.youtube.com/embed/5zTuY-Ie_VE"
            ]
        }
    },
    {
        id: 2,
        name: "Numeracy Toolbox 1: Developing Adult Learners’ Number Skills",
        slug: slugify("Numeracy Toolbox 1: Developing Adult Learners’ Number Skills"),
        icon: "🔢",
        tileDescription: "For educators: Build your confidence and skills to deliver high-quality numeracy provision to lower-skilled adults.",
        overview: "This course supports educators to deliver high quality numeracy provision to lower skilled adult learners. It is applicable to a variety of educational environments such as community courses, formal courses, or workplace courses. It is suitable for all teaching and learning support practitioners seeking to expand their understanding and practice. Note, this course is suitable for educators who do not like maths!",
        workshops: [
            "How adult difficulties with number skills interfere with course completion, workplace performance and everyday tasks",
            "Simple strategies to start delivering effective numeracy provision",
            "Strategies to develop addition and subtraction skills, multiplicative skills, and problem-solving skills within the context of tertiary programmes",
            "Support for tutors to develop their own toolbox of contextualised numeracy tasks for their program",
            "Introduction to a range of resources designed to develop learners’ skills."
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "$2,000 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "$4,500 + GST",
                deliveryMode: "A full-day in-person workshop at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Building confidence in numeracy starts with the right tools and strategies. These resources provide foundational knowledge and teaching techniques to support adult learners in developing essential number skills.",
            videos: [
                "https://www.youtube.com/embed/4y_igv_p_h0",
                "https://www.youtube.com/embed/z9v_p_9Jk4M"
            ]
        }
    },
    {
        id: 3,
        name: "Numeracy Toolbox 2: Developing learners’ fractions, decimals, percentages and proportional thinking",
        slug: slugify("Numeracy Toolbox 2: Developing learners’ fractions, decimals, percentages and proportional thinking"),
        icon: "📊",
        tileDescription: "For educators: Learn to teach fractions, decimals, and percentages in an easy and fun manner.",
        overview: "This course supports educators to deliver high-quality numeracy provision to adult learners who are required to work with decimals, percentages, fractions or proportional reasoning. Many tutors have difficulty with these concepts themselves and must teach them as part of work or course requirements. This course presents the concepts and teaching approaches in an easy and fun manner.",
        workshops: [
            "Understanding decimals, fractions, percentages and proportional reasoning",
            "The importance of proportional reasoning within the context of numeracy development, workplace competence, and problem-solving",
            "A model for developing adult learners’ numeracy skills",
            "How to use diagnostic assessment to target and develop key skills",
            "A deep-dive into specific strategies designed to effectively develop adult learners’ proportional reasoning, fraction, decimal and percentage skills",
            "Introduction to a range of resources designed to develop learners’ skills."
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "$2,000 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "$4,500 + GST",
                deliveryMode: "A full-day in-person workshop at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Fractions, decimals, and percentages can be challenging concepts. The following videos break down these topics into easy-to-understand segments and offer innovative teaching methods to make learning fun and effective.",
            videos: [
                "https://www.youtube.com/embed/do_rc3aSM2E",
                "https://www.youtube.com/embed/p_s4gE_m_aE"
            ]
        }
    },
    {
        id: 4,
        name: "Numeracy Toolbox 3: Developing measurements skills and statistical reasoning skills",
        slug: slugify("Numeracy Toolbox 3: Developing measurements skills and statistical reasoning skills"),
        icon: "📏",
        tileDescription: "For educators: Simple and effective ways to develop skills for Adult Unit Standards 26627 & 2662.",
        overview: "This course was developed to support educators working with Adult Unit Standards 26627 and 2662. It provides simple yet effective ways to develop learner’s measurement and statistical reasoning skills, and alignment with unit standard criteria.",
        workshops: [
            "Introduction to Adult Unit Standards 26627 & 2662",
            "Effective strategies for developing learner's measurement skills",
            "Practical approaches to teaching statistical reasoning",
            "Aligning learning activities with unit standard criteria",
            "Resource introduction for measurement and statistics"
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "$2,000 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "$4,500 + GST",
                deliveryMode: "A full-day in-person workshop at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Measurement and statistics are practical, real-world skills. These resources will help you teach these concepts in a hands-on, engaging way that connects with adult learners' everyday lives and professional needs.",
            videos: [
                "https://www.youtube.com/embed/wzNiu3wCoS0",
                "https://www.youtube.com/embed/7D0y_g-M5es"
            ]
        }
    },
    {
        id: 5,
        name: "Workplace Professionalism & Teamwork",
        slug: slugify("Workplace Professionalism & Teamwork"),
        icon: "🤝",
        tileDescription: "Develop key soft skills for career advancement and effective collaboration.",
        overview: "Enhance your employability and effectiveness in any professional setting. This package focuses on crucial soft skills including communication in the workplace, teamwork, problem-solving, and maintaining a professional demeanor.",
        workshops: [
            "Workshop 1: Effective Communication in a Diverse Workplace",
            "Workshop 2: Collaboration & Teamwork Dynamics",
            "Workshop 3: Problem-Solving & Decision-Making Skills",
            "Workshop 4: Professional Etiquette & Workplace Conduct",
            "Workshop 5: Giving & Receiving Constructive Feedback"
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "$2,000 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "$4,500 + GST",
                deliveryMode: "A full-day in-person workshop at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Mastering soft skills is essential for career success. The videos below cover key aspects of workplace professionalism and teamwork, from effective communication to collaborative problem-solving.",
            videos: [
                "https://www.youtube.com/embed/wAtBUIGOAcI",
                "https://www.youtube.com/embed/F4g9m2PytxA"
            ]
        }
    },
    {
        id: 6,
        name: "Dyscalculia: Supporting learner success",
        slug: slugify("Dyscalculia: Supporting learner success"),
        icon: "🧠",
        tileDescription: "Learn to support adult learners with this neurodiversity, often called 'maths dyslexia'.",
        overview: "Dyscalculia is sometimes referred to as the ‘maths version of dyslexia’, yet the differences between the two are vast. Dyscalculia is a type of neurodiversity that impacts how children process magnitude, numbers, and eventually arithmetic problems. This can make school mathematics deeply unpleasant, in fact often an assault on their sense of self-worth. By the time these children become adults, these negative experiences and ongoing difficulties have often consolidated into deep beliefs about their own mathematical inadequacy. Imagine if we could make a difference to their numeracy skills and beliefs about themselves! We can make a huge difference. In this workshop we will explore what dyscalculia is, what the research has discovered, and, most importantly, how we might work successfully with adults with dyscalculia.",
        workshops: [
            "What is dyscalculia?",
            "How is dyscalculia conceptualised and diagnosed?",
            "What does the research reveal about how dyscalculia interferes with adult life, study and employment?",
            "What strategies work with dyscalculic adults?",
            "How to design and implement effective learning plans.",
            "How to use resources in a targeted and contextualised way to support and develop learners' skills."
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "$2,000 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "$4,500 + GST",
                deliveryMode: "A full-day in-person workshop at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Understanding and supporting learners with dyscalculia can transform their educational experience. These resources offer insights into this learning difference and provide strategies to help educators create a more inclusive and effective learning environment.",
            videos: [
                "https://www.youtube.com/embed/i_H_wI2fSpg",
                "https://www.youtube.com/embed/jRDMy92dF_0"
            ]
        }
    }
];